// extracted by mini-css-extract-plugin
export var closeButton = "_on-2";
export var closeButtonIcon = "_on-3";
export var lightboxContent = "_on-1";
export var lightboxOverlay = "_on-0";